// extracted by mini-css-extract-plugin
export default {"title":"HjsZxckAIiyU3gjuF2Ss","desc-title":"TPJHZJupdAFCGNRhIjhY","btn-login":"iUJuayhaE0TkDN66RqNb"};